import { render } from "./ChevronDoubleUpIcon.vue?vue&type=template&id=568f0fd8"
import script from "./ChevronDoubleUpIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleUpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__